import { FeedbackState } from '../types';

export const FeedbackStateData: FeedbackState = {
  formData: {
    full_name: '',
    company_name: '',
    phone_number: '',
    email: '',
    company_specialization: '',
    details: '',
  },
  isLoading: false,
  error: null,
  success: false,
};
